export default function last3Digits(input: string = ''): string {
  if (typeof input !== 'string') {
    return input;
  }

  return input.slice(-3);
}
